import React from 'react';
import { Link } from 'react-router-dom';
import { Leaf } from 'lucide-react';

import AllergenNotice from '../../components/public/AllergenNotice';
import DonutGrid from '../../components/public/DonutGrid';
import PublicLayout from '../../components/public/PublicLayout';
import { Button } from '../../components/ui/button';
import { business, coreMenu, seasonalMenu, veganNote } from '../../content/siteContent.mjs';

const Menu = () => (
  <PublicLayout testId="public-menu">
    <section className="pt-16 pb-14 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-4xl mx-auto text-center">
        <p className="mb-4 text-sm font-semibold uppercase tracking-widest text-amber-600">The range</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
          Our donut menu
        </h1>
        <p className="text-lg text-gray-600 leading-relaxed">
          Brioche and buttermilk doughs made from scratch, jams cooked in our own kitchen, and a seasonal list
          that moves with the year. Everything below is available wholesale across {business.region} and for
          catering in Westchester.
        </p>
      </div>
    </section>

    <section className="py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 text-center">Signature donuts</h2>
        <p className="text-lg text-gray-600 mb-12 text-center max-w-2xl mx-auto">
          The core range — on the delivery list every week.
        </p>
        <DonutGrid items={coreMenu} testIdPrefix="menu-core" />
      </div>
    </section>

    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-amber-50/60">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 text-center">Seasonal specials</h2>
        <p className="text-lg text-gray-600 mb-12 text-center max-w-2xl mx-auto">
          Rotating flavours announced to partners as they are published — cider in the autumn, eggnog at
          Christmas, and whatever the kitchen is obsessed with that month.
        </p>
        <DonutGrid items={seasonalMenu} testIdPrefix="menu-seasonal" />
      </div>
    </section>

    <section className="py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto rounded-2xl border border-amber-200 bg-white p-8 shadow-sm">
        <div className="flex flex-col sm:flex-row items-start gap-5">
          <div className="rounded-full bg-amber-100 p-4">
            <Leaf size={26} className="text-amber-600" />
          </div>
          <div>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">Vegan versions</h2>
            <p className="text-base text-gray-600 leading-relaxed">{veganNote}</p>
          </div>
        </div>
      </div>
    </section>

    <AllergenNotice />

    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-900">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl font-bold text-white mb-5">Want these on your counter?</h2>
        <p className="text-lg text-gray-300 mb-9">
          Wholesale partners get the full range plus first call on every seasonal special.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button asChild size="lg" className="bg-amber-500 text-gray-900 hover:bg-amber-400 text-lg px-8 py-6">
            <Link to="/wholesale#inquiry" data-testid="menu-wholesale-cta">Start a wholesale inquiry</Link>
          </Button>
          <Button
            asChild
            size="lg"
            variant="outline"
            className="border-white text-white hover:bg-white hover:text-gray-900 text-lg px-8 py-6"
          >
            <Link to="/catering#quote">Order for an event</Link>
          </Button>
        </div>
      </div>
    </section>
  </PublicLayout>
);

export default Menu;
